import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import {
  SalesPortalRestaurantFieldsFragmentDoc,
  SalesPortalSupplierFieldsFragmentDoc,
} from './sales-portal-restaurant-fields.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalRestaurantListDocument = gql`
  query SalesPortalRestaurantList(
    $businessOrganizationUUID: uuid!
    $cursor: uuid
    $pageSize: Int
    $searchTerm: String
  ) {
    getSalesPortalAccountsPaginated(
      business_organization_id: $businessOrganizationUUID
      cursor: $cursor
      page_size: $pageSize
      search_term: $searchTerm
    ) {
      cursor
      accounts {
        chat_id
        on_hold
        restaurant {
          ...SalesPortalRestaurantFields
        }
        supplier {
          ...SalesPortalSupplierFields
        }
      }
    }
  }
  ${SalesPortalRestaurantFieldsFragmentDoc}
  ${SalesPortalSupplierFieldsFragmentDoc}
`;
export function useSalesPortalRestaurantListQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalRestaurantListQuery,
    Types.SalesPortalRestaurantListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalRestaurantListQuery,
    Types.SalesPortalRestaurantListQueryVariables
  >(SalesPortalRestaurantListDocument, options);
}
export function useSalesPortalRestaurantListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalRestaurantListQuery,
    Types.SalesPortalRestaurantListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalRestaurantListQuery,
    Types.SalesPortalRestaurantListQueryVariables
  >(SalesPortalRestaurantListDocument, options);
}
export type SalesPortalRestaurantListQueryHookResult = ReturnType<
  typeof useSalesPortalRestaurantListQuery
>;
export type SalesPortalRestaurantListLazyQueryHookResult = ReturnType<
  typeof useSalesPortalRestaurantListLazyQuery
>;
export type SalesPortalRestaurantListQueryResult = Apollo.QueryResult<
  Types.SalesPortalRestaurantListQuery,
  Types.SalesPortalRestaurantListQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalRestaurantListQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalRestaurantListQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalRestaurantListQuery,
    Types.SalesPortalRestaurantListQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalRestaurantListQuery,
    Types.SalesPortalRestaurantListQueryVariables
  >(SalesPortalRestaurantListDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalRestaurantListLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalRestaurantListLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalRestaurantListQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalRestaurantListQuery,
    Types.SalesPortalRestaurantListQueryVariables
  >(SalesPortalRestaurantListDocument, lazyOptions);
}
